import {
  Message
} from 'element-ui';
class VueFunctionPlugin {
  install(Vue) {
    let fnc = this
    Vue.mixin({
      created: function () {
        this.$fnc = fnc
      }
    })
  }

  /**
   * 检测文件上传
   * @param {*} file  文件信息
   * @param {Array} data  允许格式 ['doc'、'docx']
   */
  checkUploadFile(file, data = null) {
    var suffix = file.name.substring(file.name.lastIndexOf(".") + 1);
    if (!data) {
      const extension1 = suffix === "xls";
      const extension2 = suffix === "xlsx";
      const extension3 = suffix === "doc";
      const extension4 = suffix === "docx";
      const extension5 = suffix === "pdf";
      const extension6 = suffix === "zip";
      const extension7 = suffix === "rar";
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";

      if (
        !(extension1 ||
          extension2 ||
          extension3 ||
          extension4 ||
          extension5 ||
          extension6 ||
          extension7 ||
          isJPG ||
          isPNG)
      ) {
        Message({
          message: "只能上传格式为xls、xlsx、doc、docx、pdf、jpg、jpeg、png、zip、rar的文件！",
          type: "warning"
        });
        return false;
      }
    } else {
      if (!(data.indexOf(suffix) > -1)) {
        Message({
          message: "只能上传格式为" + data.join('、') + "的文件！",
          type: "warning"
        })
        return false;
      }
    }

    const isLt300M = file.size / 1024 / 1024 < 300;
    if (!isLt300M) {
      Message({
        message: "上传文件大小不能超过 300MB!",
        type: "warning"
      });

      return false;
    }
    return true;
  }

  /**
   * 验证图片上传的格式
   * * @param {*} file  文件信息
   */
  checkUploadImg(file) {
    const isJPG = file.type === "image/jpeg";
    const isPNG = file.type === "image/png";

    if (
      !(
        isJPG ||
        isPNG)
    ) {
      Message({
        message: "只能上传格式为jpg、jpeg、png的图片！",
        type: "warning"
      });
      return false;
    }
    const isLt50M = file.size / 1024 / 1024 < 50;
    if (!isLt50M) {
      Message({
        message: "上传图片大小不能超过 50MB!",
        type: "warning"
      });

      return false;
    }
    return true;
  }

  /**
   * 获取当前时间
   * @param  {Number} type [1:Y-m-d 2:Y-m-d H 3:Y-m-d H:i 4:Y-m-d H:i:s]
   * @return {[type]}      [description]
   */
  getCurrentTime(type = 1) {
    var date = new Date();
    var seperator1 = "-"
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var strDate = date.getDate()
    var hour = date.getHours()
    var minute = date.getMinutes()
    var second = date.getSeconds()
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    if (hour >= 1 && hour <= 9) {
      hour = "0" + hour
    }
    if (minute >= 1 && minute <= 9) {
      minute = "0" + minute
    }
    if (second >= 1 && second <= 9) {
      second = "0" + second
    }
    let current = year + seperator1 + month + seperator1 + strDate
    switch (type) {
      case 1:
        break;
      case 2:
        current = current + " " + hour
        break;
      case 3:
        current = current + " " + hour + ":" + minute
        break;
      case 4:
        current = current + " " + hour + ":" + minute + ":" + second
        break;
    }
    return current
  }

  dateFormat(date, type = 1) {
    var date = new Date(date);
    var seperator1 = "-"
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var strDate = date.getDate()
    var hour = date.getHours()
    var minute = date.getMinutes()
    var second = date.getSeconds()
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    if (hour >= 1 && hour <= 9) {
      hour = "0" + hour
    }
    if (minute >= 1 && minute <= 9) {
      minute = "0" + minute
    }
    if (second >= 1 && second <= 9) {
      second = "0" + second
    }
    let current = year + seperator1 + month + seperator1 + strDate
    switch (type) {
      case 1:
        break;
      case 2:
        current = current + " " + hour
        break;
      case 3:
        current = current + " " + hour + ":" + minute
        break;
      case 4:
        current = current + " " + hour + ":" + minute + ":" + second
        break;
    }
    return current
  }
}

const VueFunc = new VueFunctionPlugin()

export default VueFunc



// WEBPACK FOOTER //
// ./src/api/fnc.js